import { formatCurrency, formatDate } from "../../../utils/formatters";
import Badge from "../../common/Badge";
import { Calendar, Ticket, Package, TrendingUp } from "lucide-react";


const statusConfig = {
  0: { label: "Upcoming", variant: "info" },
  1: { label: "Live",     variant: "success" },
  2: { label: "Past",     variant: "default" },
  3: { label: "Payout Requested", variant: "warning" },
  4: { label: "Completed", variant: "success" },
};
const ProgressBar = ({ sold, total }) => {
  const pct = total > 0 ? Math.min((sold / total) * 100, 100) : 0;
  const color =
    pct >= 90 ? "bg-secondary" : pct >= 50 ? "bg-primary" : "bg-primary/60";
  return (
    <div className="w-full bg-bg-base rounded-full h-1.5">
      <div
        className={`h-1.5 rounded-full ${color} transition-all`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

const StatItem = ({ icon, label, value, highlight }) => (
  <div className="flex items-center justify-between py-2 border-b border-border last:border-0">
    <div className="flex items-center gap-1.5 text-xs text-text-muted">
      {icon}
      {label}
    </div>
    <span
      className={`text-xs font-semibold ${highlight ? "text-primary" : "text-text-secondary"}`}
    >
      {value}
    </span>
  </div>
);

const EventReportCard = ({ event }) => {
const status = statusConfig[event.status] ?? statusConfig[0];
  const ticketProgress =
    event.totalTickets > 0
      ? Math.round((event.ticketsSold / event.totalTickets) * 100)
      : 0;

  return (
    <div className="bg-bg-surface border border-border rounded-2xl overflow-hidden card-hover">
      {/* Header */}
      <div className="p-4 border-b border-border">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-sm font-semibold text-text-primary truncate">
            {event.title}
          </h3>
          <Badge label={status.label} variant={status.variant} />
        </div>
        <div className="flex items-center gap-1.5 text-xs text-text-muted">
          <Calendar size={11} className="text-primary" />
          {formatDate(event.date)}
        </div>
      </div>

      {/* Ticket progress */}
      <div className="px-4 py-3 border-b border-border">
        <div className="flex items-center justify-between text-xs text-text-muted mb-1.5">
          <span className="flex items-center gap-1">
            <Ticket size={11} />
            {event.ticketsSold} / {event.totalTickets} tickets
          </span>
          <span
            className={ticketProgress >= 90 ? "text-secondary font-medium" : ""}
          >
            {ticketProgress}%
          </span>
        </div>
        <ProgressBar sold={event.ticketsSold} total={event.totalTickets} />
      </div>

      {/* Stats */}
      <div className="px-4 py-1">
        <StatItem
          icon={<Ticket size={11} />}
          label="Ticket Revenue"
          value={formatCurrency(event.ticketRevenue)}
        />
        <StatItem
          icon={<Package size={11} />}
          label="Extras Revenue"
          value={formatCurrency(event.extrasRevenue)}
        />
        <StatItem
          icon={<TrendingUp size={11} />}
          label="Total Revenue"
          value={formatCurrency(event.ticketRevenue + event.extrasRevenue)}
          highlight
        />
      </div>
    </div>
  );
};

export default EventReportCard;
